import React, { useState } from "react";
import { Col, Container, Row, Accordion } from "react-bootstrap";
import Ecommerce from "../../images/services/cto/Ecommerce.svg";
import RealEstate from "../../images/services/cto/RealEstate.svg";
import Gaming from "../../images/services/cto/Gaming.svg";
import Healthcare from "../../images/services/cto/Healthcare.svg";
import Lifestyle from "../../images/services/cto/lifestyle.svg";
import { LazyLoadImage } from "react-lazy-load-image-component";

function Industries(props) {
  const [toggleState, setToggleState] = useState(1);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  const getActiveClass = (index, className) =>
    toggleState === index ? className : "";

  return (
    <div className="seriveces_industries p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={7} xl={7} xxl={7}>
            <div className="example" data-text="We Serve">
              <h2>Industries We Serve</h2>
            </div>
            <p className="strong">
              Find out the services we offer that apply to various industries to
              change their current infrastructure to enhance innovation and high
              performance. In healthcare, real estate, gaming, e-commerce, and
              lifestyle brands, we are the dynamic partner that gives a
              customized response to the specific needs of each business sphere,
              enhancing efficiency and scaling up.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="deskstop_version"
          >
            <div className="process_icons">
              <ul>
                <li
                  className={`tabs ${getActiveClass(1, "active-tabs")}`}
                  onClick={() => toggleTab(1)}
                >
                  <div className="iconss">
                    <LazyLoadImage
                      src={Healthcare}
                      effect="blur"
                      alt="Healthcare"
                      className="img-fluid"
                    />
                  </div>
                  Healthcare
                </li>
                <li
                  className={`tabs ${getActiveClass(2, "active-tabs")}`}
                  onClick={() => toggleTab(2)}
                >
                  <div className="iconss">
                    <LazyLoadImage
                      src={RealEstate}
                      effect="blur"
                      alt="Real Estate"
                      className="img-fluid"
                    />
                  </div>
                  Real Estate
                </li>

                <li
                  className={`tabs ${getActiveClass(3, "active-tabs")}`}
                  onClick={() => toggleTab(3)}
                >
                  <div className="iconss">
                    <LazyLoadImage
                      src={Gaming}
                      effect="blur"
                      alt="Gaming"
                      className="img-fluid"
                    />
                  </div>
                  Gaming
                </li>
                <li
                  className={`tabs ${getActiveClass(4, "active-tabs")}`}
                  onClick={() => toggleTab(4)}
                >
                  <div className="iconss">
                    <LazyLoadImage
                      src={Ecommerce}
                      effect="blur"
                      alt="Ecommerce"
                      className="img-fluid"
                    />
                  </div>
                  Ecommerce
                </li>
                <li
                  className={`tabs ${getActiveClass(5, "active-tabs")}`}
                  onClick={() => toggleTab(5)}
                >
                  <div className="iconss">
                    <LazyLoadImage
                      src={Lifestyle}
                      effect="blur"
                      alt="Lifestyle"
                      className="img-fluid"
                    />
                  </div>
                  Lifestyle
                </li>
              </ul>

              <div
                className={
                  toggleState === 1 ? "content d-block" : "content d-none"
                }
              >
                <p>
                  In healthcare, the infrastructure migration services we offer
                  through our help with getting data for patients and secure
                  communication among medical personnel are smooth jobs. We are
                  bridging gaps in healthcare operations to help in clinching
                  better patient outcomes as well as reduce operational burdens.
                </p>
              </div>
              <div
                className={
                  toggleState === 2 ? "content d-block" : "content d-none"
                }
              >
                <p>
                  The services provided by us simplify and facilitate property
                  management by real estate agents, improve communication
                  platforms, and offer realtors tools driven by data.
                  Consequently, we enable them to operate from modern, high-tech
                  infrastructures which increase their competitiveness in the
                  market.
                </p>
              </div>
              <div
                className={
                  toggleState === 3 ? "content d-block" : "content d-none"
                }
              >
                <p>
                  With a gaming provider like us, you can benefit from our
                  solutions that provide scalability of online game platforms,
                  no latencies in multiplayer game experiences, and robust data
                  analysis abilities. We aid the developers in creating fun and
                  transfiguring gaming involving active players and give them
                  the message to reach out.
                </p>
              </div>
              <div
                className={
                  toggleState === 4 ? "content d-block" : "content d-none"
                }
              >
                <p>
                  The infrastructure we offer is conducive to online shop
                  fronts, order management systems run properly, and customer
                  experience is personalized for e-commerce businesses. That is
                  how we propel growth in revenue base, and customer endearment
                  in the digital shopping arena.
                </p>
              </div>
              <div
                className={
                  toggleState === 5 ? "content d-block" : "content d-none"
                }
              >
                <p>
                  For businesses in lifestyle areas such as fashion, travel,
                  entertainment, and many others, our services in infrastructure
                  migration are available. We have scaled up content management,
                  customer engagement, and e-commerce integration to allow
                  brands to connect with their audience and succeed in the
                  digital age.
                </p>
              </div>
            </div>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mobile_version"
          >
            <div className="tekrevol_mobile_accordion_side">
              <Accordion defaultActiveKey="1">
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    <LazyLoadImage
                      src={Healthcare}
                      effect="blur"
                      alt="Healthcare"
                      className="img-fluid"
                    />
                    Healthcare
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      In healthcare, the infrastructure migration services we
                      offer through our help with getting data for patients and
                      secure communication among medical personnel are smooth
                      jobs. We are bridging gaps in healthcare operations to
                      help in clinching better patient outcomes as well as
                      reduce operational burdens.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    <LazyLoadImage
                      src={RealEstate}
                      effect="blur"
                      alt="Real Estate"
                      className="img-fluid"
                    />
                    Real Estate
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      The services provided by us simplify and facilitate
                      property management by real estate agents, improve
                      communication platforms, and offer realtors tools driven
                      by data. Consequently, we enable them to operate from
                      modern, high-tech infrastructures which increase their
                      competitiveness in the market.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    <LazyLoadImage
                      src={Gaming}
                      effect="blur"
                      alt="Gaming"
                      className="img-fluid"
                    />
                    Gaming
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      With a gaming provider like us, you can benefit from our
                      solutions that provide scalability of online game
                      platforms, no latencies in multiplayer game experiences,
                      and robust data analysis abilities. We aid the developers
                      in creating fun and transfiguring gaming involving active
                      players and give them the message to reach out.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                    <LazyLoadImage
                      src={Ecommerce}
                      effect="blur"
                      alt="Ecommerce"
                      className="img-fluid"
                    />
                    Ecommerce
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      The infrastructure we offer is conducive to online shop
                      fronts, order management systems run properly, and
                      customer experience is personalized for e-commerce
                      businesses. That is how we propel growth in revenue base,
                      and customer endearment in the digital shopping arena.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="5">
                  <Accordion.Header>
                    <LazyLoadImage
                      src={Lifestyle}
                      effect="blur"
                      alt="Lifestyle"
                      className="img-fluid"
                    />
                    Lifestyle
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      For businesses in lifestyle areas such as fashion, travel,
                      entertainment, and many others, our services in
                      infrastructure migration are available. We have scaled up
                      content management, customer engagement, and e-commerce
                      integration to allow brands to connect with their audience
                      and succeed in the digital age.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Industries;
